'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z' });

var TrendingUp = function TrendingUp(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

TrendingUp = (0, _pure2.default)(TrendingUp);
TrendingUp.muiName = 'SvgIcon';

exports.default = TrendingUp;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/TrendingUp.js
// module id = 2961
// module chunks = 0